import { Classificavel, Classificacao } from '../../../../classificacao';
import { TipoClassificacao } from '../../../../tipo-classificacao';

export class ClienteAnaliseMercadoLancamentoClassificacaoCreate implements Classificavel {
    idTipoClassificacao: number;
    tipoClassificacao: TipoClassificacao;
    idClassificacao: number;
    classificacao: Classificacao;
    /** Se pode editar a classificação */
    canEdit: boolean;
    /** Flag se é obrigatório ou não informar a classificação - Herda a configuração do Grupo de Classificações */
    obrigatorio: boolean;
}
